/**
 * Applicant-style info description panels (pale amber surface + amber border), aligned with
 * help popovers on `features/applicant/pages/Signature.tsx`.
 *
 * Compose {@link DESCRIPTION_TOOLTIP_SURFACE} with positioning and padding in each caller.
 */
export const DESCRIPTION_TOOLTIP_SURFACE =
    "rounded-lg border-2 border-amber-200 bg-amber-50 text-slate-700 shadow-md"

/** Small diamond “arrow” for popovers that open below the trigger (matches {@link DESCRIPTION_TOOLTIP_SURFACE}). */
export const DESCRIPTION_TOOLTIP_ARROW_UP =
    "absolute left-3 top-0 z-10 h-2.5 w-2.5 -translate-y-1/2 rotate-45 border-l border-t border-amber-200 bg-amber-50"

/** Hover label under an info icon (e.g. Property Product Information — “All time in ET”). */
export const DESCRIPTION_TOOLTIP_INLINE_HOVER =
    "pointer-events-none absolute left-1/2 top-full z-20 mt-2 max-w-[calc(100vw-2rem)] -translate-x-1/2 whitespace-nowrap rounded-lg border-2 border-amber-200 bg-amber-50 px-3 py-1.5 text-xs text-slate-700 shadow opacity-0 transition-opacity group-hover:opacity-100 sm:text-sm"
